import { render, staticRenderFns } from "./ConfigAlertGelf.vue?vue&type=template&id=d09b0a98&scoped=true"
import script from "./ConfigAlertGelf.vue?vue&type=script&lang=js"
export * from "./ConfigAlertGelf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d09b0a98",
  null
  
)

export default component.exports